import {
	FacilityDetailsPageContentDataByFacilityIdDocument,
	FacilityDetailsPageContentDataByFacilityIdQuery,
} from '@/graphql/__generated/sdk';

import { getGraphQLClientForContentful } from '@src/lib/graphql/client';
import { logWarning } from '@utils/miscUtils';

export type FacilityDetailsPageContentData = NonNullable<
	NonNullable<FacilityDetailsPageContentDataByFacilityIdQuery['facilityDetailsPageCollection']>['items'][number]
>;

export const getFacilityDetailsPageContentDataByFacilityId = async (
	facilityId: string,
	url: string,
	preview = false
): Promise<FacilityDetailsPageContentData | null> => {
	try {
		if (!facilityId) {
			return null;
		}

		const gqlClient = getGraphQLClientForContentful(url, preview);

		if (gqlClient === null) {
			logWarning('GQL_CLIENT_IS_NULL: missing token for fetching contentful data');
			return null;
		}

		const response = await gqlClient.query(FacilityDetailsPageContentDataByFacilityIdDocument, {
			facilityId,
			preview,
		});

		const items = response.data?.facilityDetailsPageCollection?.items ?? [];
		return (
			items.find((item: FacilityDetailsPageContentData | null): item is FacilityDetailsPageContentData =>
				Boolean(item)
			) ?? null
		);
	} catch (err) {
		logWarning(`Error fetching facility details page content data by facility id: ${String(err)}`);
		return null;
	}
};
